module.exports = __webpack_public_path__ + "media/images/panels/panel-5-beteiligung-c6ddb55b132cc211b376e489edb04891.jpg";